<template>
    <v-autocomplete
    v-model="localSelectedID"
    :items="mappedBuilds"
    :search-input.sync="search"
    :filter="customFilter"
    item-text="fullName"
    item-value="id"
    placeholder="Search . . ."
    hide-details
    class="crx-input pt-0 crx-input-override"
    spellcheck="false"
    :clearable="clearable">

    <template
    slot="selectionn"
    slot-scope="{ item, selected }">
      <div style="display: flex;flex-wrap:nowrap;align-items:center;">
        <v-list-tile-avatar
        size="30px"
        color="teal accent-3"
        class="headline font-weight-light white--text">
          {{ item.fullName.charAt(0) }}
        </v-list-tile-avatar>
        <span class="blue-grey--text">
          {{ item.fullName }}
        </span>
      </div>
    </template>

    <template 
    slot="no-data">
      <v-list-tile>
        <v-list-tile-title>
          No matching
          <strong>builds</strong>
        </v-list-tile-title>
      </v-list-tile>
    </template>

    <template
    slot="item"
    slot-scope="{ item, tile }">

    <v-layout class="underline-pseudo">

      <v-list-tile-avatar
      color="green accent-3"
      class="headline font-weight-light white--text">
        {{ item.fullName.charAt(0) }}
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-html="highlight($store.state.db.inventoryDefinitions.definitions[item.inventory_item_id].name)"></v-list-tile-title>
        <v-list-tile-sub-title v-html="highlight(item.name)"></v-list-tile-sub-title>
      </v-list-tile-content>

      </v-layout>

    </template>

    </v-autocomplete>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    selectedID: null,
    clearable: false
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapState({
      builds: state => Object.values(state.db.productBuilds.builds)
    }),
    mappedBuilds () {
      return this.builds.map(item => {
        item.definitionName = this.$store.state.db.inventoryDefinitions.definitions[item.inventory_item_id].name
        item.fullName = item.definitionName + ' - ' + item.name
        return item
      })
    },
    keywords () {
      return (this.search || '').toLowerCase().split(' ')
    },
    currentlySelectedText () {
      if (this.selectedID) {
        var selectedBuild = this.mappedBuilds[this.localSelectedID]
        return this.$store.state.db.inventoryDefinitions.definitions[selectedBuild.inventory_item_id].name
      }
      return null
    },
    localSelectedID: {
      get () {
        return this.selectedID
      },
      set (nv) {
        this.$emit('update:selectedID', nv)
      }
    }
  },
  methods: {
    customFilter (item, queryText, itemText) {
      return this.keywords.every(keyword => {
        return (item.fullName).toLowerCase().indexOf(keyword) > -1
      })
    },
    highlight (str) {
      // var replacedStr = (this.search || '').replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')
      var replacedStr = (this.search || '').replace(/ /g, '|')
      return str.replace(new RegExp(replacedStr, 'gi'), match => {
        return '<span class="blue-grey--text text--lighten-2">' + match + '</span>'
      })
    }
  }
}
</script>

<style scoped>
.underline-pseudo::after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    flex: 1 1 0px;
    height: 0px;
    max-height: 0px;
    border: solid;
    border-width: thin 0 0 0;
    border-color: rgba(0,0,0,0.12);
    transition: inherit;
    margin-left: 56px;
}
</style>


